import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function post(body) {
    return await postMethod('/api/campaigns', body)
}

async function get(request) {
    return await getMethod('/api/campaigns', request)
}

async function put(id, request) {
    return await putMethod(`/api/campaigns/${id}`, request)
}

async function patch(id, request) {
    return await patchMethod(`/api/campaigns/${id}`, request)
}

export {post, get, put, patch}
